import { render, staticRenderFns } from "./UploadWholesalePromotionModal.vue?vue&type=template&id=3e86e086&scoped=true&"
import script from "./UploadWholesalePromotionModal.vue?vue&type=script&lang=js&"
export * from "./UploadWholesalePromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadWholesalePromotionModal.vue?vue&type=style&index=0&id=3e86e086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e86e086",
  null
  
)

export default component.exports